<template>
<div class="shipDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' :title="type==1?'批量发货':'确认发货'" :visible.sync="dialogVisible" width="600px">
        <div class="title" v-if="type==1">您将对{{item.orderno.length}}个订单进行批量发货，统一填写快递信息</div>
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm form">
            <el-form-item label="快递公司" prop="shipcompanyname" class="content">
                <el-input v-model.trim="item.shipcompanyname" placeholder="请输入快递公司" clearable></el-input>
            </el-form-item>
            <el-form-item label="快递单号" prop="shipno" class="content">
                <el-input v-model.trim="item.shipno" placeholder="请输入快递单号" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {uploadShipInfo} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'shipDialog',
    data() {
        return {
            dialogVisible: false,
            item: {
                orderno: [],
                shipcompanyname: '',
                shipno: ''
            },
            rules: {
                shipno: [
                    {required: true, message: '请输入快递公司', trigger: 'blur'}
                ],
                shipcompanyname: [
                    {required: true, message: '请输入快递单号', trigger: 'blur'}
                ]
            },
            type: 2
        }
    },
    mounted() {
    },
    methods: {
        openDialog(row) {
            this.dialogVisible = true
            this.type = row.type
            this.item.orderno = row.orderno
        },
        cancel() {
            this.item.shipcompanyname = ''
            this.item.shipno = ''
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认发货', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._save()
                    })
                }
            })
        },
        _save() {
            let obj = this._.cloneDeep(this.item)
            obj.orderno = obj.orderno.join(',')
            this.setLoading(true)
            uploadShipInfo({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('发货成功')
                    this.$emit('refresh')
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.shipDialog {
    .title{
        color:  #303133;
        font-size: 14px;
        margin-bottom: 20px;
    }
    .form{
        margin-top: 0;
    }
}
</style>
